var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHuman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 128,
    fill: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.581 192.335C93.0437 192.335 64.2368 163.529 64.2368 127.993C64.2368 92.4562 93.0437 63.65 128.581 63.65C153.315 63.65 174.786 77.6025 185.557 98.0658H222.889C210.217 58.1534 172.861 29.2341 128.747 29.2341C74.2026 29.2341 29.9863 73.4493 29.9863 127.993C29.9863 182.536 74.2026 226.751 128.747 226.751C171.75 226.751 208.331 199.268 221.889 160.912H183.877C172.651 179.729 152.087 192.335 128.581 192.335ZM106.302 116.022V142.956Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226.011 116.022H106.301V142.956H226.011V116.022Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuman);
export default __webpack_public_path__ + "static/media/human.a4b7db086010502adb1d26957c2cab49.svg";
export { ForwardRef as ReactComponent };